import React from "react";
import { useAuth } from "lib/firebase-provider/Auth";

export default function PermissionedComponent({ children, isAllowed }) {
  const { user, claims } = useAuth();
  const currentUser = user;

  if (!currentUser) {
    return <div />;
  }

  if (isAllowed(claims)) {
    return children
  }

  return <div/>;
}
